import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class StripeProduct extends BaseModel {
  public id: string;
  public name: string;

  constructor(model: Partial<StripeProduct> = {}) {
    super();

    this.id = model.id as string;
    this.name = model.name as string;
  }
}
